import { READ_EMPLOYEE_PERMISSION } from '../model';
import { useIsCurrentEmployee } from '../route/hooks/useIsCurrentEmployee';
import useEmployeePermissionsMap from './useEmployeePermissionsMap';

const useIsEmployeeProfileAccessible = (alias?: Nullable<string>) => {
  const isCurrentEmployee = useIsCurrentEmployee();
  const isOwnProfile = isCurrentEmployee(alias);
  const { permissionsMap } = useEmployeePermissionsMap(isOwnProfile ? [] : [alias]);

  return isOwnProfile || Boolean(alias && permissionsMap[alias]?.includes(READ_EMPLOYEE_PERMISSION));
};

export default useIsEmployeeProfileAccessible;
